import {
  Badge,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@bleu.builders/ui";
import { LinkIcon, UsersIcon } from "lucide-react";
import React from "react";

import { Link } from "#/components/Link";
import { useUser } from "#/contexts/UserContext";
import {
  DialogTemplatedMessage,
  TemplateMessage,
} from "#/components/CreateEmailLink";

export const MultiDiagnosisFeatureNotice = () => {
  const { user } = useUser();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="w-full justify-start">
          <UsersIcon className="mr-2 size-4" />
          Gerar link para múltiplos diagnósticos
          <Badge className="ml-2 bg-orange-500 hover:bg-orange-400">Novo</Badge>
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[550px]">
        <Card className="w-full max-w-none bg-background border-0 shadow-none px-0">
          <CardHeader className="justify-center items-center">
            <LinkIcon className="text-[#ffffff] bg-[#555050] p-3 size-16 shadow-md rounded-full" />
            <CardTitle className="text-xl">Novidade no Recuperar!</CardTitle>
            <CardDescription className="py-0 text-sm">
              Um único link compartilhável, múltiplos diagnósticos
            </CardDescription>
          </CardHeader>
          <CardContent className="w-full flex gap-2 justify-center items-center">
            <DialogTemplatedMessage
              template={TemplateMessage.REUSABLE_DIAGNOSIS_LINK_CREATION}
              firstName={user.first_name}
              email={user.email}
            >
              <Button variant="outline" className="w-full">
                Saiba mais
              </Button>
            </DialogTemplatedMessage>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
};
